import React, { useState } from "react";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/react-hooks";
import { useHistory } from "react-router-dom";
import querystring from "query-string";

import { SearchInput } from "./styles";

import { GET_CREATOR_PROFILE_INFO } from "core/ProfileHeader/queries";

import { SEARCH_ICONS_CREATOR } from "data/links";

const SearchIcons = ({ username }) => {
    const { data, loading } = useQuery(GET_CREATOR_PROFILE_INFO, {
        variables: {
            username
        }
    });

    const [query, setQuery] = useState("");
    const history = useHistory();

    const handleSubmit = e => {
        e.preventDefault();

        if (query === "") return;

        const queryString = querystring.stringify({
            q: query,
            name: data && data.info.name,
            avatarUrl: data && data.info.avatarUrl
        });
        const searchResultsUrl = `${SEARCH_ICONS_CREATOR.replace(
            ":username",
            encodeURIComponent(username)
        )}?${queryString}`;

        history.push(searchResultsUrl);
    };

    if (loading) return null;

    return (
        <form onSubmit={handleSubmit}>
            <SearchInput
                size="md"
                value={query}
                onChange={e => setQuery(e.target.value)}
                placeholder="Search icons by creator"
            />
        </form>
    );
};

SearchIcons.props = {
    username: PropTypes.string.isRequired
};

export default SearchIcons;
